import { render, staticRenderFns } from "./CloFooter.vue?vue&type=template&id=17c65fca&"
import script from "./CloFooter.vue?vue&type=script&lang=js&"
export * from "./CloFooter.vue?vue&type=script&lang=js&"
import style0 from "./CloFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports